import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../models/tracer.model';
import { isOrderChangeNotif } from './message-tab-label-pipe';

// True when a Request is a provider-initiated callback rather than a
// call made through our platform. Today the only such method is
// OrderChangeNotif (the provider pushes an order-change notification
// and our platform acknowledges it). The request-list sidebar uses
// this to flag those tiles so an operator immediately sees the row
// did not originate from a consumer/our API.
@Pipe({
  name: 'isProviderCallback',
})
export class IsProviderCallbackPipe implements PipeTransform {
  transform(req: Request | null | undefined): boolean {
    if (!req) return false;
    return isOrderChangeNotif(req.Method) || isOrderChangeNotif(req.ProviderMethod);
  }
}
